import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { MenuItem } from "./_models";
import { User } from "./_models/user-models/user";
import { LocalStorageService } from "./_services";
import { AppMainComponent } from "./app.main.component";

@Component({
  selector: "app-menu",
  templateUrl: "./app.menu.component.html",
})
export class AppMenuComponent implements OnInit {
  menuItems: any[];
  client: User = new User();

  constructor(private router: Router, public appMain: AppMainComponent) {}

  ngOnInit() {
    this.basicInit();
  }

  private basicInit() {
    // Fetch client information from local storage service
    this.client = LocalStorageService.getUserStorageValue();

    // Get menu items from local storage
    this.menuItems = JSON.parse(localStorage.getItem("MENU") || "[]");

    // Subscribe to router events to update active route
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.resetMenuItems();
        this.setActiveRoute();
      }
    });

    // Set the initial active route
    this.setActiveRoute();
  }

  // Reset all menu items to collapse them initially and remove active states
  resetMenuItems() {
    this.menuItems.forEach((item) => {
      this.resetItem(item);
    });
  }

  resetItem(item: MenuItem) {
    item.expanded = false;
    item.isActive = false; // Reset active state
    if (item.items) {
      item.items.forEach((subItem) => {
        this.resetItem(subItem);
      });
    }
  }

  setActiveRoute() {
    this.menuItems.forEach((item) => {
      this.markActive(item, this.router.url);
    });
  }

  markActive(item: MenuItem, currentUrl: string) {
    // If the current item matches the route, mark it as active
    if (item.routerLink && item.routerLink.includes(currentUrl)) {
      item.isActive = true;
      item.expanded = true;
    }

    // If the item has children, recursively check and set the active state
    if (item.items) {
      let hasActiveChild = false;
      item.items.forEach((subItem) => {
        this.markActive(subItem, currentUrl);
        if (subItem.isActive || subItem.expanded) {
          hasActiveChild = true; // If any child or grandchild is active, mark the current item expanded
        }
      });

      // If any child is active, expand this item
      if (hasActiveChild) {
        item.expanded = true;
      }
    }
  }

  menuHide(menu: any) {
    let res = true;
    menu.jobType.forEach((element) => {
      if (element == this.client.JobType || element == this.client.OrgType) {
        res = false;
      }

      if (element == "All") {
        res = false;
      }

      if (element == "SP") {
        res = false;
      }
    });
    return res;
  }

  onMenuClick() {
    this.appMain.menuClick = true;
  }
}
